import { createTransform } from 'redux-persist'

import type { DadosPessoaisState } from './types'

type DadosPessoaisPersistSlice = Pick<
  DadosPessoaisState,
  'isValidModalityAccount' | 'postDadosPessoaisLoading' | 'correctionMode' | 'rejectedBankAccount'
>

export const withoutPersistedModalityAccount = <T extends DadosPessoaisPersistSlice>(
  state: T,
): Omit<
  T,
  'isValidModalityAccount' | 'postDadosPessoaisLoading' | 'correctionMode' | 'rejectedBankAccount'
> & {
  isValidModalityAccount: null
  postDadosPessoaisLoading: false
  correctionMode: false
  rejectedBankAccount: null
} => ({
  ...state,
  isValidModalityAccount: null,
  postDadosPessoaisLoading: false,
  correctionMode: false,
  rejectedBankAccount: null,
})

export const modalityAccountPersistTransform = createTransform<
  DadosPessoaisPersistSlice,
  DadosPessoaisPersistSlice
>(
  (inbound: DadosPessoaisPersistSlice) => withoutPersistedModalityAccount(inbound),
  (outbound: DadosPessoaisPersistSlice) => withoutPersistedModalityAccount(outbound),
  { whitelist: ['dadosPessoais'] },
)
